import React from 'react';
import formatDbTimestamp from '../components/common/formatDbTimestamp';
import downloadIcon from '../images/downloadIcon.png';
import Button from '../components/common/Button'

import ReactHtmlParser, {
    convertNodeToElement,
    processNodes
  } from "react-html-parser";

  import { animated, useSpring } from "react-spring";
import { toTitleCase } from '../util/titleCase';

const ChatCard = (props) => {   

    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
    const firstname = toTitleCase(studentInfo[0].firstname);
    const surname = toTitleCase(studentInfo[0].surname);
    const name = `${firstname}${" "}${surname}`;

    function transform(node, index) {
        // all links must open in a new window
        if (node.type === "tag" && node.name === "a") {
          node.attribs.target = "_blank";
          return convertNodeToElement(node, index, transform);
        }
      
        if (node.type === "tag" && node.name === "button") {
          return (
            <Button key={index}>
              {processNodes(node.children, transform)}
            </Button>
          );
        }
    } 
      
    const HtlmParserOptions = {
    decodeEntities: true,
    transform
    };

    const transitionStylesYou = useSpring({
        to: [
        { transform: 'translateX(0px)' },
        ],
        from: { transform: 'translateX(80px)' },
        config: { duration: 750 }
    });

    const transitionStylesIncoming = useSpring({
        to: [
        { transform: 'translateX(0px)' },
        ],
        from: { transform: 'translateX(-80px)' },
        config: { duration: 750 }
    });

    return (
                (props.userName !== name) && (props.userName !== 'You') ?
                <animated.div style={transitionStylesIncoming}>
                <div className='w-full'>
                    <div className='pt-4 sm:px-8'>
                        <div className='w-full flex'>
                            <div className='mr-4'>
                                <img src={props.profilePix} alt='incoming' className='chatAvatar object-cover rounded-full' />
                            </div>
                            <div className='flex flex-col  bg-white px-2 sm:px-4 pb-4 chatBoxShadow rounded-r-xl rounded-bl-xll mb-2 pt-4'>
                                <div className='flex justify-between items-center space-x-2'>
                                    <span className='text-blue-100 text-xs font-semibold'> {toTitleCase(props.userName)} </span>
                                    <span className='chatTime text-gray-200'> {props.timestamp ? formatDbTimestamp(props.timestamp) : props.time} </span>
                                </div>
                                <div className='mt-3 text-xs sm:text-sm text-gray-200 leading-5 h-full max-w-full'>
                                    {
                                    props.messagetype === "video" ?
                                    <video
                                        style={{ maxWidth: '100%' }}
                                        src={props.message ? props.message : ''} alt="watch"
                                        type="video/mp4" controls
                                    /> :
                                    props.messagetype === "image" ?
                                        <img
                                            style={{ maxWidth: '100%' }}
                                            src={props.message ? props.message : ''}
                                            alt="picture message"
                                        />
                                    :
                                    props.messagetype === "doc" ?
                                        <a
                                            style={{ maxWidth: '100%' }}
                                            href={props.message ? props.message : ''}
                                            alt="doc message"
                                            target='_blank'
                                        >
                                            <span className='w-full flex justify-center items-center px-2 my-2 bg-gray-700 rounded'>
                                                <span className="mr-2 my-2 cursor-pointer py-2 text-blue-100 text-sm font-semibold"> 
                                                    {props.message.substring(35)} 
                                                </span>
                                                <span className='w-5'>
                                                    <img src={downloadIcon} className='w-full' alt='download Icon' />
                                                </span>
                                            </span>
                                        </a>
                                    :
                                    props.messagetype === "audio" ?
                                        <audio
                                            style={{ maxWidth: '100%' }}
                                            src={props.message ? props.message : ''}
                                            controls
                                        >
                                            Your browser does not support
                                            <code>audio</code> files.
                                        </audio>
                                    :
                                    <p className='mt-1 text-xs sm:text-sm text-gray-200 leading-5 '>
                                        {ReactHtmlParser(props.message, HtlmParserOptions)}
                                    </p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </animated.div>
            :
            <>
                <animated.div style={transitionStylesYou} className='max-w-full'>
                    <div className='pt-4 sm:ml-8 -mr-8'>
                        <div className='w-full flex justify-end pr-5 sm:pr-20'>
                            <div className='flex flex-col chatBoxShadow bg-blue-800 px-4 mr-4 rounded-r-xl rounded-bl-xl py-3'>
                                <div className='flex justify-between items-center space-x-2'>
                                    <span className='text-blue-100 text-xs font-semibold'> You </span>
                                    <span className='chatTime text-gray-200'> {props.timestamp ? formatDbTimestamp(props.timestamp) : props.time} </span>
                                </div>
                                <div className='mt-1 text-xs sm:text-sm text-gray-200 leading-5 chatAvatar h-full w-full'>
                                    {
                                    props.messagetype === "video" ?
                                        <video
                                            style={{ maxWidth: '100%' }}
                                            src={props.message ? props.message : ''} alt="watch"
                                            type="video/mp4" controls
                                        /> :
                                    props.messagetype === "image" ?
                                        <img
                                            style={{ maxWidth: '100%' }}
                                            src={props.message ? props.message : ''}
                                            alt="picture message"
                                        />
                                    :
                                    props.messagetype === "pdf" || props.messagetype === 'others' ?
                                        <a
                                            style={{ maxWidth: '100%' }}
                                            href={props.message ? props.message : ''}
                                            alt="doc message"
                                            target='_blank'
                                        >
                                            <span className='w-full flex justify-center items-center px-2 my-2 bg-gray-700 rounded'>
                                                <span className="mr-2 my-2 cursor-pointer py-2 text-blue-100 text-sm font-semibold"> 
                                                    {props.message.substring(35)} 
                                                </span>
                                                <span className='w-5'>
                                                    <img src={downloadIcon} className='w-full' alt='download Icon' />
                                                </span>
                                            </span>
                                        </a>
                                    :
                                    props.messagetype === "audio" ?
                                        <audio
                                            style={{ maxWidth: '100%' }}
                                            src={props.message ? props.message : ''}
                                            controls
                                        >
                                            Your browser does not support
                                            <code>audio</code> files.
                                        </audio>
                                    :
                                    <p className='mt-1 text-xs sm:text-sm text-gray-200 leading-5 chatAvatar h-full w-full'>
                                        {ReactHtmlParser(props.message, HtlmParserOptions)}
                                    </p>}
                                </div>
                                
                            </div>
                            <div className='mr-4'>
                                <img src={props.profilePix ? props.profilePix : props.image} alt='current user' className='chatAvatar object-cover rounded-full' />
                            </div>
                        </div>
                    </div>
                </animated.div>
            </>
            
    )
}

export default ChatCard